import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementBlock as _createElementBlock, renderSlot as _renderSlot, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-5b7ce6c1"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "node-empty-state" };
const _hoisted_2 = { class: "node-empty-state-content" };
const _hoisted_3 = {
    key: 0,
    class: "icon-heading"
};
const _hoisted_4 = { class: "blob" };
const _hoisted_5 = {
    key: 0,
    class: "node-empty-state-action"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_EmptyStateBlob = _resolveComponent("EmptyStateBlob");
    const _component_FriedIcon = _resolveComponent("FriedIcon");
    const _component_FriedH3 = _resolveComponent("FriedH3");
    const _component_FriedParagraph = _resolveComponent("FriedParagraph");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            (_ctx.icon || _ctx.heading)
                ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                    _createElementVNode("div", _hoisted_4, [
                        _createVNode(_component_EmptyStateBlob),
                        (_ctx.icon)
                            ? (_openBlock(), _createBlock(_component_FriedIcon, {
                                key: 0,
                                icon: _ctx.icon
                            }, null, 8, ["icon"]))
                            : _createCommentVNode("", true)
                    ]),
                    (_ctx.heading)
                        ? (_openBlock(), _createBlock(_component_FriedH3, { key: 0 }, {
                            default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.heading), 1)
                            ]),
                            _: 1
                        }))
                        : _createCommentVNode("", true)
                ]))
                : _createCommentVNode("", true),
            (_ctx.description)
                ? (_openBlock(), _createBlock(_component_FriedParagraph, { key: 1 }, {
                    default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.description), 1)
                    ]),
                    _: 1
                }))
                : _createCommentVNode("", true)
        ]),
        (_ctx.$slots.action)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _renderSlot(_ctx.$slots, "action", {}, undefined, true)
            ]))
            : _createCommentVNode("", true)
    ]));
}
